import { jsx } from 'react/jsx-runtime';
import { XmarkIcon } from '@flex-design-system/legacy-flex-icons';
import { composeEventHandlers } from '@radix-ui/primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { PrimitiveButton } from '../../../button/primitive-button/PrimitiveButton.mjs';
import { useLinearLocale } from '../../../locale/LocaleContext.mjs';
import { useChipContext } from '../../context.mjs';
import { chipClearButton } from './clearButton.vanilla.mjs';

const CHIP_CLEAR_BUTTON_ARIA_LABEL_RECORD = {
  ko: "\uC9C0\uC6B0\uAE30",
  en: "Clear"
};
const ChipClearButton = forwardRef(
  ({
    className: classNameFromProps,
    color = "black040",
    onKeyDown,
    onPointerDown,
    ...props
  }, forwardedRef) => {
    const { locale } = useLinearLocale();
    const { size, state } = useChipContext("Chip.ClearButton");
    const className = classNames(chipClearButton({ size }), classNameFromProps);
    const handleKeyDown = composeEventHandlers(
      onKeyDown,
      (event) => event.stopPropagation()
    );
    const handlePointerDown = composeEventHandlers(
      onPointerDown,
      (event) => event.stopPropagation()
    );
    return /* @__PURE__ */ jsx(
      PrimitiveButton,
      {
        "aria-label": CHIP_CLEAR_BUTTON_ARIA_LABEL_RECORD[locale],
        "data-scope": "chip",
        "data-part": "clear-button",
        "data-chip-state": state,
        className,
        onKeyDown: handleKeyDown,
        onPointerDown: handlePointerDown,
        ref: forwardedRef,
        ...props,
        children: /* @__PURE__ */ jsx(XmarkIcon, { "aria-hidden": true, color, size: 18 })
      }
    );
  }
);
ChipClearButton.displayName = "Chip.ClearButton";

export { ChipClearButton };
//# sourceMappingURL=ClearButton.mjs.map
